import React from 'react'

import {noop} from 'es-toolkit'
import invariant from 'invariant'

import {useAppDispatch, useAppSelector} from '../../../hooks/redux'
import {closeModal} from '../../../redux/features/modal'

import {priceFormulaOptionsMap} from '../../forms/pricings/utils'

import {ModalMeta, Price, PriceFormula} from '../../../types'

import Headline from '../../../../../commons/src/components/headline'
import Modal from '../../../../../commons/src/components/modal'
import SelectField from '../../../../../commons/src/components/select-field'
import SelectMenu from '../../../../../commons/src/components/select-menu'
import Stack from '../../../../../commons/src/components/stack'

import CreatePricingFormPartial from '../../pricings/create-pricing-form-partial'

type Props = {
  meta: ModalMeta
  onDone?: (price: Price) => void
}

const formulaOptions = Object.values(priceFormulaOptionsMap).map(option => ({
  label: option.label,
  value: option.value,
}))

const CreatePricingModal = ({meta, onDone = noop}: Props) => {
  const [formulaOption, setFormulaOption] = React.useState<{
    label: string
    value: PriceFormula
  }>(formulaOptions[0])

  const dispatch = useAppDispatch()
  const provider = useAppSelector(state => state.core.provider)
  invariant(provider, 'Provider is missing.')

  return (
    <Modal
      fullscreenMobile={meta.fullscreenMobile}
      headline={<Headline label="Create new pricing" size="l" />}
      onClose={() => dispatch(closeModal())}
    >
      <Stack>
        <Stack space="70">
          <Headline size="s" label="Formula" className="u-no-margin-bottom" />
          <SelectField
            value={formulaOption}
            onChange={value => {
              setFormulaOption(value)
            }}
            menu={<SelectMenu values={formulaOptions} />}
          />
        </Stack>
        <CreatePricingFormPartial
          provider={provider}
          formula={formulaOption.value}
          hidePriceCalculator
          onDone={(createdPrice: Price) => {
            dispatch(closeModal())
            onDone(createdPrice)
          }}
        />
      </Stack>
    </Modal>
  )
}

export default CreatePricingModal
